import { useAlertDispatch } from 'app/store/alertDispatch';
import { useEffect, useState } from 'react';

function AlertComponent() {
    const { async, error, info, success, warning, asyncMsg, errorMsg, infoMsg, warningMsg } = useAlertDispatch()
    const [alert, setAlert] = useState('');

    useEffect(() => {
        if (error) {
            setAlert(errorMsg);
        } 
        else if (info) {
            setAlert(infoMsg);
        }
        else if (warning) {
            setAlert(warningMsg);
        } 
        else if (async) {
            setAlert(asyncMsg);
        }

        return () => {
            setAlert('');
        }
    }, [async, error, info, success, warning])

    if (async || error || info || warning) {
        return (
            <p className={`font-400 w-auto min-h-[54px] max-h-[54px] rounded-[4px] text-[#11100f] border-[0.6px] border-[#2266e3b9] px-[48px] flex flex-row items-center justify-center absolute left-[41%] z-50 top-16 mx-auto`}>
                {alert}
            </p>
        );
    }
    else return null
}

export default AlertComponent